export default class Log {
	static projectId = '';
	
	static init(pid){
		Log.projectId = pid;
		let text = localStorage.getItem('dy-log-' + pid);
		if(!text) text = '';
		
		let elem = document.getElementsByClassName('dy-log-info')[0];
		
		if(elem) elem.innerHTML = text;
	}
	
	static clear(){
		localStorage.setItem('dy-log-' + Log.projectId, '');
		let elem = document.getElementsByClassName('dy-log-info')[0];
		
		if(elem) elem.innerHTML = '';
	}
	
	static write(projectId, text, color){
		let elem = document.getElementsByClassName('dy-log-info')[0];
		
		if(elem) elem.innerHTML = '<div style="color:' + color + '">' + text + '</div>' + elem.innerHTML;
		
		localStorage.setItem('dy-log-' + projectId, elem.innerHTML);
	}
	
	static info(projectId, text){
		write(text, '#eee');
	}
	
	static error(projectId, text){
		write(text, '#c33');
	}
	
	static success(projectId, text){
		write(text, '#6c6');
	}
	
	static warning(projectId, text){
		write(text, '#cc3');
	}
}